export const beforeItems: string[] = [
  'Searching YouTube at 10pm for a drill that might work',
  "Sessions that fall apart because you don't know what comes next",
  'Girls standing in lines, bored, drifting away from the sport',
  'No idea whether you are teaching the right skill for their age',
  'Rules you cannot explain when a parent asks',
]

export const afterItems: string[] = [
  'A full season planned block by block before you start',
  'The exact words to say, printed in the Coach Script Box',
  'Every drill with setup, timing, progressions and corrections',
  'Age-appropriate content from U8 first sticks to U17 competitive play',
  "Women's rules explained in plain English on a single sheet",
  'Print it Sunday night, coach it Monday afternoon',
]
